import { Capacitor } from '@capacitor/core'
import { useAppConfig } from '../../hooks/challenge/useAppConfig'
import { useInstalledAppVersion } from '../../hooks/util/useInstalledAppVersion'
import styles from '../../ui/onboarding/GuardView.module.css'
import LoadingIndicator from '../../ui/util/LoadingIndicator'
import VersionUtil from '../../util/VersionUtil'
import UpdateAppButton from './UpdateAppButton'

export default function ForceUpdateView({ children }: { children: React.ReactNode }) {
  const { data: appConfig, isLoading } = useAppConfig()
  const { data: installedVersion, isLoading: isLoadingInstalledVersion } = useInstalledAppVersion()

  if (isLoading || isLoadingInstalledVersion) {
    return (
      <div className={styles.loading}>
        <LoadingIndicator />
      </div>
    )
  }

  const isWeb = Capacitor.getPlatform() === 'web'
  if (isWeb || !installedVersion) return <>{children}</>

  if (!appConfig?.iosVersion || !appConfig?.androidVersion) return <>{children}</>

  const requiredVersion =
    Capacitor.getPlatform() === 'ios' ? appConfig.iosVersion : appConfig.androidVersion
  const needsUpdate = VersionUtil.isOlder(installedVersion, requiredVersion)

  if (!needsUpdate) return <>{children}</>

  return (
    <div className={styles.wrap}>
      <h1 className={styles.title}>Update first</h1>
      <p className={styles.description}>
        We release updates to add and fix things. To make sure you get the latest and greatest, we
        make you update. Go update and come back to the app!
      </p>
      <UpdateAppButton />
    </div>
  )
}
